const XW_FEATURED_COLLECTION = {
  wrapper_class: ".slider-wrapper",
  product_class: ".grid__item.slider__slide",
  show_all: "button-show-all-hidden-products",
  hide_all: "button-hide-all-hidden-products",
};

// Funzione helper per gestire la visibilità dei prodotti
const updateProductVisibility = () => {
  const hiddenProducts = document.querySelectorAll(
    `${XW_FEATURED_COLLECTION.product_class}.show-on-mobile`
  );
  if (window.innerWidth < 990) {
    hiddenProducts.forEach((product) => {
      product.style.display = "list-item";
    });
  } else {
    hiddenProducts.forEach((product) => {
      product.style.display = "none ";
    });
  }
};

document.addEventListener("click", (e) => {
  if (e.target.classList.contains(XW_FEATURED_COLLECTION.show_all)) {
    const sliderProductsWrapper = e.target.closest(
      XW_FEATURED_COLLECTION.wrapper_class
    );
    const sliderProducts = sliderProductsWrapper.querySelectorAll(
      XW_FEATURED_COLLECTION.product_class
    );
    sliderProducts.forEach((product) => {
      product.style.display = "list-item";
    });
    sliderProductsWrapper
      .querySelector(`.${XW_FEATURED_COLLECTION.show_all}`)
      .classList.add("hidden");
    sliderProductsWrapper
      .querySelector(`.${XW_FEATURED_COLLECTION.hide_all}`)
      .classList.remove("hidden");
  } else if (e.target.classList.contains(XW_FEATURED_COLLECTION.hide_all)) {
    const sliderProductsWrapper = e.target.closest(
      XW_FEATURED_COLLECTION.wrapper_class
    );
    const sliderProducts = sliderProductsWrapper.querySelectorAll(
      XW_FEATURED_COLLECTION.product_class
    );
    sliderProducts.forEach((product, index) => {
      if (index > 7 && window.innerWidth >= 990) {
        product.style.display = "none";
      } else {
        product.style.display = "list-item";
      }
    });

    sliderProductsWrapper
      .querySelector(`.${XW_FEATURED_COLLECTION.show_all}`)
      .classList.remove("hidden");
    sliderProductsWrapper
      .querySelector(`.${XW_FEATURED_COLLECTION.hide_all}`)
      .classList.add("hidden");
  }
});

window.addEventListener("resize", () => {
  updateProductVisibility();
});

document.addEventListener("DOMContentLoaded", () => {
  updateProductVisibility();
});
